// extracted by mini-css-extract-plugin
export default {"CriteriaSection__criteriaCardContainer":"CriteriaSection-styles__CriteriaSection__criteriaCardContainer__mU3mM"};